(function () {
  'use strict';

  function initNumberedSlider(section) {
    var card = section.querySelector('[data-autoplay]');
    if (!card) return;

    var slideCopies = section.querySelectorAll('.madesa-numbered-slider__slide-copy');
    var slideMedias = section.querySelectorAll('.madesa-numbered-slider__slide-media');
    var numberBtns = section.querySelectorAll('.madesa-numbered-slider__num[data-go-to]');
    var playPauseBtn = section.querySelector('[data-play-pause]');

    var total = slideCopies.length;
    if (total === 0) return;

    var i18nAriaPause = card.getAttribute('data-i18n-aria-pause') || 'Pause autoplay';
    var i18nAriaResume = card.getAttribute('data-i18n-aria-resume') || 'Resume autoplay';
    var i18nTitlePause = card.getAttribute('data-i18n-title-pause') || 'Pause';
    var i18nTitleResume = card.getAttribute('data-i18n-title-resume') || 'Play';

    var current = 0;
    var autoplay = card.getAttribute('data-autoplay') === 'true';
    var speedSec = parseInt(card.getAttribute('data-autoplay-speed'), 10) || 5;
    var intervalId = null;
    var activeVideo = null;

    function setProgress(value) {
      if (!playPauseBtn) return;
      var p = Math.max(0, Math.min(1, value));
      playPauseBtn.style.setProperty('--progress', p);
    }

    function updateProgress() {
      if (!activeVideo || activeVideo.readyState < 2) {
        setProgress(0);
        return;
      }
      var duration = activeVideo.duration;
      if (!duration || !isFinite(duration)) {
        setProgress(0);
        return;
      }
      setProgress(activeVideo.currentTime / duration);
    }

    function bindVideoProgress(video) {
      if (activeVideo && activeVideo !== video) {
        activeVideo.removeEventListener('timeupdate', updateProgress);
        activeVideo.removeEventListener('loadedmetadata', updateProgress);
      }
      activeVideo = video;
      if (!video) {
        setProgress(0);
        return;
      }
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('loadedmetadata', updateProgress);
      updateProgress();
    }

    function goToSlide(index) {
      index = ((index % total) + total) % total;
      current = index;

      slideCopies.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      slideMedias.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
        var video = el.querySelector('video');
        if (video) {
          if (i === index) {
            video.muted = true;
            video.currentTime = 0;
            video.play().catch(function () {});
            bindVideoProgress(video);
          } else {
            video.pause();
          }
        } else if (i === index) {
          bindVideoProgress(null);
        }
      });
      numberBtns.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
    }

    function startAutoplay() {
      if (intervalId) return;
      intervalId = setInterval(function () {
        goToSlide(current + 1);
      }, speedSec * 1000);
    }

    function stopAutoplay() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function getActiveVideo() {
      var activeSlide = section.querySelector('.madesa-numbered-slider__slide-media.is-active');
      return activeSlide ? activeSlide.querySelector('video') : null;
    }

    function setPaused(paused) {
      card.setAttribute('data-paused', paused ? 'true' : 'false');
      if (playPauseBtn) {
        playPauseBtn.setAttribute('aria-label', paused ? i18nAriaResume : i18nAriaPause);
        playPauseBtn.setAttribute('title', paused ? i18nTitleResume : i18nTitlePause);
      }
      if (paused) {
        stopAutoplay();
        var video = getActiveVideo();
        if (video) video.pause();
      } else {
        var video = getActiveVideo();
        if (video) {
          video.muted = true;
          video.play().catch(function () {});
        }
        if (autoplay) startAutoplay();
      }
    }

    function togglePause(ev) {
      if (ev) ev.preventDefault();
      var paused = card.getAttribute('data-paused') === 'true';
      setPaused(!paused);
    }

    numberBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        goToSlide(i);
        if (card.getAttribute('data-paused') !== 'true' && autoplay) {
          stopAutoplay();
          startAutoplay();
        }
      });
    });

    /* Delegação: clique no botão ou em qualquer filho (ex.: SVG) aciona pause/play */
    section.addEventListener('click', function (ev) {
      var btn = playPauseBtn;
      if (btn && (ev.target === btn || btn.contains(ev.target))) {
        ev.preventDefault();
        togglePause(ev);
      }
    });

    if (autoplay) {
      startAutoplay();
    }

    /* Garante que o vídeo do slide ativo esteja tocando (e os outros pausados) */
    goToSlide(current);
  }

  function init() {
    var sections = document.querySelectorAll('.madesa-numbered-slider[data-section-id]');
    sections.forEach(initNumberedSlider);
  }

  window.initNumberedSlider = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.madesa-numbered-slider[data-section-id]');
    if (section) initNumberedSlider(section);
  });
})();
